<script setup lang="ts">
  import type { ID, Maybe } from '@/types'
  import type { CustomerCartProductListItemType } from '@/types/customer/products'
  import type { CustomerAccount } from '@/types/ui'

  import { reactify } from '@vueuse/core'

  import { findByPropValue } from '@/helpers'

  import CustomerCartProductListItem from '@/components/Global/Customer/Cart/CustomerCartProductListItem.vue'

  const props = defineProps<{
    items: CustomerCartProductListItemType[]
    cartItems: CustomerAccount['cartItems']
    editable?: boolean
    dense?: boolean
  }>()
  const emit = defineEmits<{
    (e: 'change-amount', { id, amount }: { id: ID; amount?: number }): void
  }>()

  function getProduct(id: ID): Maybe<CustomerCartProductListItemType> {
    return findByPropValue(props.items, id, 'id')
  }

  const reactiveGetProduct = reactify(getProduct)
</script>

<template>
  <div class="py-2">
    <CustomerCartProductListItem
      v-for="cartItem in props.cartItems"
      :key="`item-${cartItem.product_id}`"
      :item="reactiveGetProduct(cartItem.product_id)"
      :amount="cartItem.amount"
      :editable="props.editable"
      :dense="props.dense"
      @change-amount="({ id, amount }) => emit('change-amount', { id, amount })"
    />
  </div>
</template>
